import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomFormComponent } from '@bo-client/activation-management/custom-form.component';
import { DataForCustomFormModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommissioningRequestDtoModel } from '@bo-client/activation-management/shared/models/commissioningRequestDto';
import { CreateFormsCommissioningService } from '@bo-client/activation-management/commissioning/forms/create-forms-commissioning.service';
import { AreaTypeEnum } from '@bo-client/activation-management/shared/models/commissioningModel';

@Component({
  selector: 'app-cr-completition-form',
  templateUrl: './cr-completition-form.component.html',
  styleUrls: ['./cr-completition-form.component.scss']
})
export class CrCompletitionFormComponent
  implements CustomFormComponent<CommissioningRequestDtoModel, CommissioningRequestDtoModel>, OnInit
{
  @Input() data: DataForCustomFormModel<CommissioningRequestDtoModel>;
  @Output() onConfirm: EventEmitter<CommissioningRequestDtoModel> = new EventEmitter();

  public model: CommissioningRequestDtoModel;
  public currentForm: FormGroup;
  get connectionPowerUnit(): string {
    switch (this.model.area.name) {
      case AreaTypeEnum.POWER:
        return 'kVa';
      case AreaTypeEnum.WATER:
        return 'm³/h';
      default:
        return 'kVa';
    }
  }

  get actionFormGroups() {
    return this.currentForm?.get('actions') as FormArray;
  }

  constructor(private fb: FormBuilder, private formService: CreateFormsCommissioningService) {}

  ngOnInit(): void {
    this.model = this.data.model;

    this.currentForm = this.fb.group({
      actions: this.fb.array(
        this.data.model.actions.map((data) =>
          this.formService.createActionsForm(data, <AreaTypeEnum>this.model.area.name, 'CompletionForm')
        )
      ),
      supplyAppointment: [this.model.supplyAppointment, [Validators.required]],
      comment: []
    });
    //this.currentForm = this.createFormsGridRegistrationService.createFeedinManagementConfigurationForm(
    //  this.data.model
    //);
    /**
     * für jede aktion mit einem Zähler?
     * => Zä
     */
  }

  cancel() {
    this.onConfirm.emit(null);
  }

  confirm() {
    if (this.currentForm.valid) {
      this.model.actions = (this.currentForm.get('actions') as FormArray).value;
      this.model.supplyAppointment = this.currentForm.get('supplyAppointment').value;

      this.onConfirm.emit(this.model);
    } else {
      this.currentForm.markAllAsTouched();
    }
  }
}
